<script>
import { list } from '@/api/tabelapreco'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ tabela: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="tabela"
    width="1000"
    component="app-tabelapreco-grid"
    label="Tabela Preço"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
